import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-main" }
const _hoisted_2 = { class: "l-error c-card" }
const _hoisted_3 = { class: "l-error__inner" }
const _hoisted_4 = { class: "l-error__btn" }
const _hoisted_5 = { class: "c-buttonWrap4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonLink = _resolveComponent("ButtonLink")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "l-error__message" }, [
          _createElementVNode("h1", null, [
            _createTextVNode(" 404 Not Found"),
            _createElementVNode("br"),
            _createTextVNode(" お探しのページが見つかりません。 ")
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(" お探しのページは一時的にアクセスができない状況にあるか、"),
            _createElementVNode("br", { class: "c-displayPc" }),
            _createTextVNode(" 移動もしくは削除された可能性があります。 ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ButtonLink, {
              tag: "a",
              href: /home/,
              "style-type": "primary",
              color: "color2"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" トップページへ ", -1)
              ])),
              _: 1,
              __: [0]
            })
          ])
        ])
      ])
    ])
  ]))
}